export default __webpack_public_path__ + "static/media/playstore.218489e2.png";